var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSearchAlt = function SvgSearchAlt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 21,
    fill: "none",
    viewBox: "0 0 22 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#323338",
    strokeWidth: 1.5,
    d: "M8.972 1.465a7.265 7.265 0 1 1 0 14.53 7.265 7.265 0 0 1 0-14.53Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#323338",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m15.12 14.342 5.326 5.327"
  })));
};
export default SvgSearchAlt;